import { useState, useEffect } from "react";
import { Button, Box, TextField, Avatar } from "@mui/material";
import { UseWalletManage } from "./UseWalletManage";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { useRecoilState } from "recoil";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { removeComma, toMoney } from "../../util/Utils";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddWalletOffer() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [offer, setOffer] = useState();
  const { AddOffer, validate } = UseWalletManage();
  const [imgState, setImgState] = useState({
    file: undefined,
    url: undefined,
  });
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [state, setState] = useState({
    id: undefined,
    title: undefined,
    cost1: 0,
    cost2: 0,
  });
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    title: false,
    file: false,
    cost1: false,
  });

  const handleChangeImage = (e) => {
    setImgState({
      ...imgState,
      file: e.target.files[0],
      url: URL.createObjectURL(e.target.files[0]),
    });
  };

  useEffect(() => {
    if (location.state && location.state.model) {
      var lastRowIndex = Math.max.apply(
        Math,
        location.state.model.map(function (o) {
          return o.id + 1;
        })
      );
      setState({ ...state, id: lastRowIndex != -Infinity ? lastRowIndex : 1 });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/walletManagment" },
          { name: "آفر جدید", url: "/walletManagment/addWalletOffer" },
        ],
      }}
    >
      <Box display="grid" gap={3}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مبلغ کارت"
              size="small"
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              error={errorState.cost1}
              value={state.cost1 ? toMoney(state.cost1) : ""}
              onChange={(evt) => {
                setState({
                  ...state,
                  cost1: removeComma(evt.target.value),
                });
              }}
              variant="outlined"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مبلغ هدیه"
              size="small"
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={state.cost2 ? toMoney(state.cost2) : ""}
              onChange={(evt) => {
                setState({
                  ...state,
                  cost2: removeComma(evt.target.value),
                });
              }}
              variant="outlined"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 5"} component="label">
            <Avatar
              sx={{
                border: "1px solid #d9d9d9",
                borderRadius: 3,
                width: "200px",
                height: "100%",
                p: 1,
              }}
              src={imgState.url ? imgState.url : "/static/img/nobanner.jpg"}
              alt="img"
            />
            <input
              type="file"
              id="img"
              name="avatarName"
              accept="image/*"
              multiple
              onChange={handleChangeImage}
              hidden
            />
          </Box>
          {!isSmall && <Box gridColumn="span 7"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "70px" }}
              variant="contained"
              onClick={() => {
                if (validate(state, imgState, setErrorState, true) == 200) {
                  setProgress(true);
                  AddOffer(state, imgState.file, () => {
                    setMsGotoLast(true);
                    navigate("/walletManagment", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "70px" }}
              variant="outlined"
              onClick={() => {
                navigate("/walletManagment", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
        </Box>
      </Box>
    </Detail>
  );
}
